import {
  BONUS_BUTTON_MODAL_VIEWED, BONUS_BUTTON_MODAL_CLOSED,
  BONUS_BUTTON_POPUP_VIEWED, BONUS_BUTTON_POPUP_EXPANDED, BONUS_BUTTON_POPUP_COLLAPSED,
} from './types';

export const triggerBonusButtonModalIsViewedGaEvent = () => ({
  type: BONUS_BUTTON_MODAL_VIEWED,
});

export const triggerBonusButtonModalIsClosedGaEvent = () => ({
  type: BONUS_BUTTON_MODAL_CLOSED,
});

export const triggerBonusButtonPopupIsViewedGaEvent = (isQualified, leftAmount) => ({
  type: BONUS_BUTTON_POPUP_VIEWED,
  isQualified,
  leftAmount,
});

export const triggerBonusButtonModalIsExpandedGaEvent = (isQualified) => ({
  type: BONUS_BUTTON_POPUP_EXPANDED,
  isQualified,
});

export const triggerBonusButtonPopupIsCollapsedGaEvent = (isQualified) => ({
  type: BONUS_BUTTON_POPUP_COLLAPSED,
  isQualified,
});
